<template lang="pug">
  v-layout.overlay(row wrap @click="$emit('close')")
    v-layout.modal-layer(row wrap v-if="val")
      slot
        v-flex.modal#modal_top.pa-5.pb-5(xs12 md8)
          span.close(@click="$emit('close')") ✕
          v-layout.modal_contents(row wrap)
            v-layout(row wrap)
              h3 {{ val.title }}
              p.text-xs-center.my-3 {{ val.text }}
            v-layout.justify-center(row wrap)
              v-flex(xs12 sm6)
                v-img(:src="'/static/images/recipe/' + val.id + '.jpg'" contain)
              v-flex(xs12 offset-sm1 sm5)
                h4 材料
                dl
                  span(v-for='(n , index) in val.ingredients')
                    dt {{ n.ingredient }}
                    dd {{ n.quantity }}
            v-layout(row wrap)
              h4 作り方
              ul.pl-2
                li(v-for='(n , index) in val.directions') {{ n.direction }}
            v-layout(row wrap).mt-3
              img.mr-2(src='/static/images/recipe/recipe_pic_comment.png' width=80 height=30 alt='ひとこと')
              p.mt-1 {{ val.comment }}

</template>

<script>

export default {
  name: 'Modal',
  props: ['val', 'list']
}
</script>

<style scoped lang="stylus">
// breakpoint
screen-xs = 600px
screen-sm = 960px
breakpoint(bpName)
    for name in bpName
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}

// color
$color-primary = #3e2723
$color-secondary = #ecddbc
.overlay
  position fixed
  z-index 3
  width 100%
  height 100%
  overflow scroll
  top 0
  left 0
  background rgba($color-primary , .3)
  display flex
  align-items center
  justify-content center
  .modal-layer
    display flex
    align-items center
    justify-content center
    .modal
      position relative
      height 90vh
      box-shadow 2px 2px 2px rgba($color-primary , .1)
      border-radius 10px
      cursor pointer
      background-color white
      .modal_contents
        height 75vh
        overflow-y scroll
        .close
          color rgba($color-primary , .5)
          font-weight 700
          font-size 1.5rem
          cursor pointer
          float right
        h3
          white-space pre
          border-bottom 2px solid $color-primary
          padding-bottom 1rem
        h4
          background #a47c52
          color white
          margin 1rem 0
        dt,dd,li
          font-size .9rem
        dl
          dt
            float left
          dd
            text-align right
        li
          list-style-type decimal
          margin-left 1rem
</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Modal.vue